import ApiClient from "../../../apiClient";
import { BASE_URL, REPORTS } from "../../../constant/apiEndPoint";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const fetchDailyPointReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${REPORTS.DAILY_POINTS}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_DAILY_CUSTOMER_POINT_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_DAILY_CUSTOMER_POINT_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchRedeemRewardReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${REPORTS.REWARD_REDEEM}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_REWARD_REDEEM_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_REWARD_REDEEM_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchSubscribedCustomerReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${REPORTS.SUBSCRIBED_CUSTOMER}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_SUBSCRIBED_CUSTOMER_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_SUBSCRIBED_CUSTOMER_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchCustomerReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${REPORTS.CUSTOMER}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_CUSTOMER_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_CUSTOMER_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchOfflineGoldTransactionReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${REPORTS.OFFLINE_GOLD_TRANSACTION}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_OFFLINE_GOLD_TRANSACTION_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_OFFLINE_GOLD_TRANSACTION_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchSubscriptionReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${REPORTS.SUBSCRIPTION}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_SUBSCRIPTION_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_SUBSCRIPTION_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const fetchAllTransactionReport = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${REPORTS.ALL_TRANSACTION}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_TRANSACTION_REPORT_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_ALL_TRANSACTION_REPORT_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const clearOfflineGoldPurchase = () => ({
  type: TYPE.CLEAR_OFFLINE_GOLD_PURCHASE,
});
